import { Pipe, PipeTransform } from '@angular/core';
import { GboxAnswer, ScanAnswerRef } from '@/tms/reports/_models/reports.model';

@Pipe({ name: 'firstScanRef', standalone: true })
export class FirstScanRefPipe implements PipeTransform {
	transform(answers: GboxAnswer[] | null | undefined): ScanAnswerRef | null {
		for (const answer of answers ?? []) {
			if (answer.scan) {
				return answer.scan;
			}
		}
		return null;
	}
}
